import { SoundCloud } from './soundcloud';

export const Audios: React.FC = () => {
  return (
    <>
      <SoundCloud link="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/284611239&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true" />
    </>
  );
};
